import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Grid
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import SaveIcon from '@material-ui/icons/Save';
import { Form, Formik } from 'formik';
import { withSnackbar } from 'notistack';
import React, { useRef } from 'react';
import FacturaInput from '../../../components/inputs/FacturaInput';
import InputFileWithFormik from '../../../components/inputs/InputFileWithFormik';
import InputWithFormik from '../../../components/inputs/InputWithFormik';
import KeyboardDatePickerWithFormik from '../../../components/inputs/KeyboardDatePickerWithFormik';
import NumberInput from '../../../components/inputs/NumberInput';
import {
  Yup,
  schemaCurrency,
  schemaFile,
  schemaWithDateTransform
} from '../../../utils/form-utils';
import FormikSubmitEffect from './FormikSubmitEffect';

const styles = theme => ({
  innerContainer: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.down('sm')]: {
      padding: 0
    }
  },
  innerContainerBeneficiario: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(3)
  },
  textInnerContainerBeneficiario: {
    fontSize: 15,
    color: '#686b69',
    paddingLeft: 5
  },
  leftPadding: {
    paddingLeft: theme.spacing(3 / 2),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0
    }
  },
  rightPadding: {
    paddingRight: theme.spacing(3 / 2),
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0
    }
  }
});

const FacturaFields = () => {
  return (
    <>
      <Grid item xs={12} md={6}>
        <InputWithFormik
          label="Número"
          name="nroFactura"
          required
          InputProps={{ inputComponent: FacturaInput }}
        />
        <FormHelperText variant="outlined">
          Factura de ejemplo: 001-001-0001234
        </FormHelperText>
      </Grid>
      <Grid item xs={12} md={6}>
        <InputWithFormik label="Timbrado" name="timbrado" required />
      </Grid>
      <Grid item xs={12} md={6}>
        <KeyboardDatePickerWithFormik
          label="Fecha"
          name="fechaFactura"
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <InputWithFormik
          required
          label="Monto"
          name="montoFactura"
          tooltip="Completar con el monto total"
          InputProps={{
            inputComponent: NumberInput
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <InputFileWithFormik
          required
          label="Adjuntar factura (PDF)"
          name="factura"
          tooltip="Se debe adjuntar la factura"
        />
        <FormHelperText variant="outlined">
          Formato soportado: PDF
        </FormHelperText>
      </Grid>
    </>
  );
};

const FacturaFieldsWhitSnackbar = withSnackbar(FacturaFields);

const validationSchema = Yup.object().shape({
  nroFactura: Yup.string()
    .matches(/^\d{3}-\d{3}-\d{7}$/, 'Debe seguir el formato 123-123-1234567')
    .required(),
  timbrado: Yup.string().required(),
  fechaFactura: schemaWithDateTransform,
  montoFactura: schemaCurrency(),
  factura: schemaFile(true)
});

const FacturasAddForm = ({
  enqueueSnackbar,
  config,
  onClose,
  onChange,
  classes
}) => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const { open, defaultValue, isEdit, disabled } = config;
  const facturaConfig = {
    classes,
    isEdit,
    disabled
  };

  const onSubmitError = ({ errors }) => {
    // Validacion de Lista de Socios de la Persona Juridica
    const key = Object.keys(errors).length;
    if (key === 1 && errors.terceroJuridicas) {
      enqueueSnackbar(errors.terceroJuridicas, {
        variant: 'warning'
      });
      return;
    }

    enqueueSnackbar('Verificar formatos y campos obligatorios', {
      variant: 'warning'
    });
  };

  const onSubmit = values => {
    if (onChange) {
      onChange(values);
    }
    if (onClose) {
      onClose();
    }
  };

  const formik = useRef();

  return (
    <Dialog
      maxWidth="lg"
      open={open}
      scroll="paper"
      fullWidth
      fullScreen
      onClose={onClose}
      disableEscapeKeyDown
      classes={{
        paper: classes.dialogPaper
      }}
    >
      <DialogTitle>
        {isEdit ? 'Editar' : 'Nueva'}
        {' Factura'}
      </DialogTitle>
      <DialogContent dividers>
        <Formik
          enableReinitialize
          initialValues={{
            ...defaultValue
          }}
          innerRef={formik}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {() => (
            <Form id="miForm" noValidate>
              <FormikSubmitEffect onSubmitError={onSubmitError} />
              <Container maxWidth="md" className={classes.innerContainer}>
                <Grid container spacing={3}>
                  <FacturaFieldsWhitSnackbar {...facturaConfig} />
                </Grid>
              </Container>
            </Form>
          )}
        </Formik>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          type="button"
          size={isPhone ? 'small' : 'medium'}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          size={isPhone ? 'small' : 'medium'}
          form="miForm"
          // onClick={() => formik.current.submitForm()}
          startIcon={<SaveIcon />}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withSnackbar(withStyles(styles)(FacturasAddForm));
